import { get } from 'lodash'

export const setLazyloaded = (store, options) => {
	store.dispatch('utils/setLazyloaded', get(options, ['data-lazyloaded', 'value']))
}
